/* eslint-disable consistent-return */
import React, { useRef, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import PropTypes from 'prop-types';
import { handleRipple } from '../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainTitle,
  MainContentWrapper,
  MainText,
  ButtonWrapper,
  LeftArrowButton,
  RightArrowButton,
  CardContainer,
  CardWrapper,
  CardTitle,
  CardText,
  CardButton,
  ContentContainer,
  ImageContainer,
  CardImage,
  ContentWrapper,
  TitleWrapper,
} from './styled';

const GetStarted = ({ template }) => {
  const { messages, locale } = useIntl();
  const carouselRef = useRef(null);
  const items = messages[`${template}.get-started.items`];

  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const checkScrollPosition = () => {
    if (carouselRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;

      setShowLeftArrow(scrollLeft > 0);

      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  useEffect(() => {
    const carousel = carouselRef.current;
    if (carousel) {
      checkScrollPosition();

      carousel.addEventListener('scroll', checkScrollPosition);

      return () => {
        carousel.removeEventListener('scroll', checkScrollPosition);
      };
    }
  }, [items]);

  useEffect(() => {
    const handleResize = () => {
      setTimeout(checkScrollPosition, 100);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scroll = direction => {
    if (carouselRef.current) {
      const scrollAmount = 300;
      carouselRef.current.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <MainTitle locale={locale}>
            {messages[`${template}.get-started.title`]}
          </MainTitle>
          <MainContentWrapper>
            <MainText>{messages[`${template}.get-started.subtitle`]}</MainText>
            <ButtonWrapper>
              <LeftArrowButton
                visible={showLeftArrow}
                type="button"
                onClick={() => scroll(-1)}
                onMouseEnter={handleRipple}
              >
                <GoArrowLeft size={30} color="#ffffff" />
              </LeftArrowButton>
              <RightArrowButton
                visible={showRightArrow}
                type="button"
                onClick={() => scroll(1)}
                onMouseEnter={handleRipple}
              >
                <GoArrowRight size={30} color="#ffffff" />
              </RightArrowButton>
            </ButtonWrapper>
          </MainContentWrapper>
          <CardContainer>
            <CardWrapper ref={carouselRef}>
              {items.map((item, index) => (
                <a
                  // eslint-disable-next-line react/no-array-index-key
                  key={`get-started-${index}`}
                  href={item.link}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <ContentContainer>
                    <ImageContainer>
                      <CardImage src={item.image.src} alt={item.image.alt} />
                    </ImageContainer>
                    <ContentWrapper>
                      <TitleWrapper>
                        <CardTitle locale={locale}>{item.title}</CardTitle>
                        <CardText>{item.subtitle}</CardText>
                      </TitleWrapper>
                      <CardButton
                        onMouseEnter={handleRipple}
                        href={item.link}
                        onClick={() => {
                          window.open(item.link, '_blank');
                        }}
                      >
                        Learn more
                      </CardButton>
                    </ContentWrapper>
                  </ContentContainer>
                </a>
              ))}
            </CardWrapper>
          </CardContainer>
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

GetStarted.propTypes = {
  template: PropTypes.string.isRequired,
};

export default GetStarted;
